export default __webpack_public_path__ + "static/media/cover.e4a7491d.png";